import React, { useContext } from 'react';
import AppContext from '../context/Context';
import ProvidersRoutes from '../routes/ProvidersRoutes';

const ProvidersLayout = ( ) => {
    const { isFluid } = useContext(AppContext);

    return  <div className={isFluid ? 'container-fluid' : 'container'}>
                <ProvidersRoutes />
            </div>
}

export default ProvidersLayout;